// import { useGetFarmersFullQuery } from "features/onboarding/users/farmer/farmerApiSlice";
// import * as L from "leaflet";
// import "leaflet.markercluster";
// import "leaflet/dist/leaflet.css";
// import { useEffect, useRef, useState } from "react";
// import { useNavigate, useParams } from "react-router-dom";

// const myIcon = L.icon({
//   iconUrl: require("./marker4.jpg"),
//   iconSize: [24, 35],
//   iconAnchor: [12, 35],
//   popupAnchor: [0, -35],
// });

// const getColor = (ACS) => {
//   if (ACS === null) return "blue";
//   if (ACS < 50) return "red";
//   if (ACS >= 50 && ACS <= 60) return "yellow";
//   return "green";
// };

// const ClusterMap = () => {
//   const navigate = useNavigate();
//   const { id } = useParams();
//   const mapRef = useRef(null);
//   const markerLayerRef = useRef(null);
//   const legendRef = useRef(null); 
//   const [geoJson, setGeoJson] = useState();

//   const { data } = useGetFarmersFullQuery(
//     {
//       orgId: id,
//       pagination: "",
//       stateId: "",
//       districtId: "",
//       blockId: "",
//       searchKey: "",
//       farmerCategory: "",
//       gender: "",
//     },
//     { refetchOnMountOrArgChange: true }
//   );

//   useEffect(() => {
//     if (data?.data?.geojson) {
//       setGeoJson(data.data.geojson);
//     }
//   }, [data]);

//   useEffect(() => {
//     if (mapRef.current) return;

//     const map = L.map("mapIdd", {
//       center: [28.6591285, 77.3165729],
//       zoom: 6,
//     });
//     mapRef.current = map;

//     const googleSatellite = L.tileLayer("http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}", {
//       maxZoom: 22,
//       attribution: "© Google Satellite",
//     }).addTo(map);

//     const streetLayer = L.tileLayer("http://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}", {
//       maxZoom: 22,
//       attribution: "© Google Street View",
//     });

//     const baseLayers = {
//       "Google Satellite": googleSatellite,
//       "Google Street View": streetLayer,
//     };
//     const overlayLayers = {};
//     L.control.layers(baseLayers, overlayLayers, { collapsed: false }).addTo(map);
//   }, []);

//   useEffect(() => {
//     if (!geoJson || !mapRef.current) return;

//     const map = mapRef.current;

//     if (markerLayerRef.current) {
//       map.removeLayer(markerLayerRef.current);
//     }

//     const markers = L.markerClusterGroup();

//     const geoJsonLayer = new L.geoJson(geoJson, {
//       style: feature => ({
//         color: getColor(feature.properties.ACS),
//         weight: 2,
//         fillOpacity: 0.5,
//       }),
//       pointToLayer: function (feature, latlng) {
//         return L.marker(latlng, { icon: myIcon });
//       },
//       onEachFeature: function (feature, layer) {
//         const props = feature.properties;
//         const wrapper = document.createElement("div");
//         wrapper.className = "farmer-info-wrapper";
//         wrapper.innerHTML = `
//           <div><b>Farmer Name</b>: ${props.farmer_name}</div><br/>
//           <div><b>Mobile Number</b>: ${props.phone_number}</div><br/>
//           <div><b>State</b>: ${props.state_name}</div><br/>
//           <div><b>District</b>: ${props.district_name}</div><br/>
//           <div><b>Land Mark</b>: ${props.land_mark}</div><br/>
//           <div><b>Plot Id</b>: ${props.plot_id}</div><br/>
//           <div><b>ACS</b>: ${props.ACS ?? 0}</div>
//         `;

//         const button = document.createElement("button");
//         button.innerText = "View Details";
//         button.style.cssText = "color:white;background-color:green;padding:7px;border:none;width:100%";
//         button.onclick = () => navigate(`/onboarding/farmers/${props.farmer_id}`);
//         wrapper.appendChild(button);

//         layer.bindPopup(wrapper);
//       },
//     });

//     markers.addLayer(geoJsonLayer);
//     markers.addTo(map);
//     markerLayerRef.current = markers;

//     if (legendRef.current) {
//       legendRef.current.remove();
//     }

//     const legend = L.control({ position: "bottomright" });

//     legend.onAdd = function () {
//       const div = L.DomUtil.create("div", "info legend custom-legend");
//       const grades = ["High", "Moderate", "Low"];
//       const colors = ["green", "yellow", "red"];

//       let labels = ["<h6 style='margin-bottom: 10px;'>Farm Score</h6>"];
//       for (let i = 0; i < grades.length; i++) {
//         labels.push(
//           `<div style="display: flex; align-items: center; margin-bottom: 8px;">
//             <i style="background:${colors[i]}; width:18px; height:18px; display:inline-block; margin-right:8px; border:1px solid #000;"></i> 
//             <span style="font-size:14px;">${grades[i]}</span>
//           </div>`
//         );
//       }
//       div.innerHTML = labels.join("");
//       return div;
//     };

//     legend.addTo(map);
//     legendRef.current = legend; 

//     if (geoJson.features.length) {
//       map.fitBounds(L.geoJSON(geoJson).getBounds());
//     }
//   }, [geoJson]);

//   return (
//     <div
//       style={{ padding: 0, margin: 0, width: "100%", height: "100%", zIndex: 0 }}
//       id="mapIdd"
//       className="farmer_map"
//     />
//   );
// };

// export default ClusterMap;

import * as L from "leaflet";
import React, { useEffect, useState, useMemo } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  LayersControl,
  MapContainer,
  TileLayer,
  GeoJSON,
  Marker,
  Popup,
  useMapEvents,
  LayerGroup,
} from "react-leaflet";
import MarkerClusterGroup from "react-leaflet-cluster";
import { ReactLegendMap } from "features/dashboard/Project/ReactLegendMap";
import { useGetFarmersFullQuery } from "features/onboarding/users/farmer/farmerApiSlice";

const pointIcon = L.icon({
  iconUrl: require("./marker4.jpg"),
  iconSize: [24, 35],
  iconAnchor: [12, 35],
  popupAnchor: [0, -35],
});

const polygonCenterIcon = L.icon({
  iconUrl:
    "https://www.iconarchive.com/download/i113269/icons-land/flat-vector-map-marker/Marker-Pearl-HeadPin-Red.1024.png",
  iconSize: [0, 0],
  iconAnchor: [8, 8],
  popupAnchor: [0, -8],
});

const getColor = (ACS) => {
  if (ACS === null || typeof ACS === "object") return "blue";

  if (ACS < 50) return "red";
  if (ACS >= 50 && ACS <= 60) return "yellow";
  return "green";
};

const ZoomTracker = ({ onZoomChange }) => {
  useMapEvents({
    zoomend: (e) => onZoomChange(e.target.getZoom()),
  });
  return null;
};

const ClusterMap = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [geoJson, setGeoJson] = useState(null);
  const [bounds, setBounds] = useState(null);
  const [zoom, setZoom] = useState(5);
    const { data } = useGetFarmersFullQuery(
    {
      orgId: id,
      pagination: "",
      stateId: "",
      districtId: "",
      blockId: "",
      searchKey: "",
      farmerCategory: "",
      gender: "",
    },
    { refetchOnMountOrArgChange: true }
  );
  useEffect(() => {
    if (data?.data?.geojson) {
      setGeoJson(data.data.geojson);
    }
  }, [data]);

  useEffect(() => {
    if (geoJson) {
      try {
        const leafletBounds = L.geoJSON(geoJson).getBounds();
        setBounds(leafletBounds);
      } catch (err) {
        console.warn("Failed to compute bounds:", err);
      }
    }
  }, [geoJson]);
  const polygonFeatures = useMemo(
    () =>
      geoJson?.features?.filter(
        (feature) =>
          feature?.geometry &&
          ["Polygon", "MultiPolygon"].includes(feature.geometry.type) &&
          feature.properties
      ) || [],
    [geoJson]
  );

  const pointFeatures = useMemo(
    () =>
      geoJson?.features?.filter(
        (feature) =>
          feature?.geometry?.type === "Point" &&
          Array.isArray(feature.geometry.coordinates) &&
          feature.properties
      ) || [],
    [geoJson]
  );
 
  
  const combinedMarkers = useMemo(() => {
    const uniquePointMap = new Map();
  
    pointFeatures.forEach((feature) => {
      const plotId = feature.properties.plot_id;
      if (plotId && !uniquePointMap.has(plotId)) {
        uniquePointMap.set(plotId, feature);
      }
    });

    const pointMarkers = Array.from(uniquePointMap.values()).map(
      (feature, idx) => {
        const [lng, lat] = feature.geometry.coordinates;
        return {
          key: `point-${feature.properties.plot_id ?? `idx-${idx}`}`,
          position: [lat, lng],
          icon: pointIcon,
          plotId: feature.properties.plot_id,
          feature,
        };
      }
    );

    const existingPlotIds = new Set(pointMarkers.map((m) => m.plotId));

    const uniquePolygonMap = new Map();
    polygonFeatures.forEach((feature) => {
      const plotId = feature.properties.plot_id;
      if (
        plotId &&
        !existingPlotIds.has(plotId) &&
        !uniquePolygonMap.has(plotId)
      ) {
        uniquePolygonMap.set(plotId, feature);
      }
    });
    const polygonCenterMarkers = Array.from(uniquePolygonMap.values())
      .map((feature, idx) => {
        const bounds = L.geoJSON(feature).getBounds();
        if (!bounds.isValid()) return null;
        const latlng = bounds.getCenter();
        return {
          key: `poly-center-${feature.properties.plot_id ?? `idx-${idx}`}`,
          position: [latlng.lat, latlng.lng],
          icon: polygonCenterIcon,
          plotId: feature.properties.plot_id,
          feature,
        };
      })
      .filter(Boolean);
  
    return [...pointMarkers, ...polygonCenterMarkers];
  }, [pointFeatures, polygonFeatures]);

 
  return (
    <div style={{ position: "relative", height: "100%", width: "100%" }}>
      <MapContainer
        center={bounds ? undefined : [22, 80]}
        zoom={bounds ? undefined : 5}
        bounds={bounds}
        style={{ height: "100%", width: "100%" }}
        whenCreated={(map) => setZoom(map.getZoom())}
      >
        <ZoomTracker onZoomChange={setZoom} />

        <LayersControl collapsed={false}>
          <LayersControl.BaseLayer name="Satellite">
            <TileLayer url="https://mt0.google.com/vt/lyrs=s&hl=en&x={x}&y={y}&z={z}"  maxZoom={22}/>
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Satellite With Labels" checked>
            <TileLayer url="https://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}"  maxZoom={22} />
          </LayersControl.BaseLayer>
          <LayersControl.BaseLayer name="Streets">
            <TileLayer url="https://mt0.google.com/vt/lyrs=m&hl=en&x={x}&y={y}&z={z}"  maxZoom={22}/>
          </LayersControl.BaseLayer>

          <LayersControl.Overlay name="Plots" checked>
            <LayerGroup>
              {polygonFeatures.map((feature, idx) => (
                <GeoJSON
                  key={`polygon-${idx}`}
                  data={feature}
                  style={{
                    color: getColor(feature?.properties?.ACS ?? null),
                    weight: 2,
                    fillOpacity: 0.5,
                  }}
                  onEachFeature={(feature, layer) => {
                    const Wrapperdiv = document.createElement("div");
                    Wrapperdiv.className = "farmer-info-wrapper lineHeight";
                    Wrapperdiv.innerHTML = `<div className="farmerName">
                      <div><b>Farmer Name</b>: ${
                        feature.properties.farmer_name
                      }</div>
                      <div><b>Mobile Number</b>: ${
                        feature.properties.phone_number
                      }</div>
                      <div><b>State</b>: ${feature.properties.state_name}</div>
                      <div><b>District</b>: ${
                        feature.properties.district_name
                      }</div>
                      <div><b>Land Mark</b>: ${
                        feature.properties.land_mark
                      }</div>
                      <div><b>Plot Id</b>: ${feature.properties.plot_id}</div>
                      <div><b>ACS</b>: ${feature.properties.ACS ?? 0}</div>
                    </div>`;
                    const btn = document.createElement("button");
                    btn.innerHTML = "View Details";
                    btn.style.cssText = `
                      color: white;
                      background-color: green;
                      padding: 7px;
                      border: none;
                      width: 100%;
                      margin-top: 10px;
                    `;
                    btn.onclick = () =>
                      navigate(
                        `/onboarding/farmers/${feature.properties.farmer_id}`
                      );
                    Wrapperdiv.appendChild(btn);
                    layer.bindPopup(Wrapperdiv);
                  }}
                />
              ))}
              <MarkerClusterGroup
                chunkedLoading
                showCoverageOnHover={false}
            
              >
                {combinedMarkers.map(({ key, position, icon, feature }) => (
                  <Marker key={key} position={position} icon={icon}>
                    <Popup>
                      <div className="farmer-info-wrapper2">
                        <div className="mt-3">
                          <b>Farmer Name</b>: {feature.properties.farmer_name}
                        </div>
                        <div className="mt-3">
                          <b>Phone</b>: {feature.properties.phone_number}
                        </div>
                        <div className="mt-3">
                          <b>State</b>: {feature.properties.state_name}
                        </div>
                        <div className="mt-3">
                          <b>District</b>: {feature.properties.district_name}
                        </div>
                        <div className="mt-3">
                          <b>Land Mark</b>: {feature.properties.land_mark}
                        </div>
                        <div className="mt-3">
                          <b>Plot Id</b>: {feature.properties.plot_id}
                        </div>
                        <div className="mt-3">
                          <b>ACS</b>: {feature.properties.ACS ?? 0}
                        </div>
                        <button
                          style={{
                            color: "white",
                            backgroundColor: "green",
                            padding: "7px",
                            border: "none",
                            width: "100%",
                            marginTop: "10px",
                          }}
                          onClick={() =>
                            navigate(
                              `/onboarding/farmers/${feature.properties.farmer_id}`
                            )
                          }
                        >
                          View Details
                        </button>
                      </div>
                    </Popup>
                  </Marker>
                ))}
              </MarkerClusterGroup>
            </LayerGroup>
          </LayersControl.Overlay>
        </LayersControl>
        <ReactLegendMap />
      </MapContainer>
    </div>
  );
};

export default ClusterMap;


